export default __webpack_public_path__ + "7c49edd9e168e475958c031c995f8a22.png";